<template>
  <div class="c-url">
    <div class="c-col-field">{{ description }}</div>
    <input-len v-model="url" :placeholder="`请输入${description}`" :max="max" width="420"></input-len>
    <div class="c-col-msg" v-if="msg">
      <span>{{ msg }}</span>
    </div>
  </div>
</template>
<script>
import mixinVerify from './mixin-verify'
import InputLen from '@/components/input/input-len.vue'
export default {
  name: 'cUrl',
  mixins: [mixinVerify],
  components: { InputLen },
  props: {
    name: {
      type: String
    },
    description: {
      type: String
    },
    value: {
      type: String
    },
    min: {
      type: Number
    },
    max: {
      type: Number
    },
    default: {
      type: String
    },
    required: {
      type: Boolean
    },
    pattern: {
      type: String
    },
    verify: {
      type: Boolean
    }
  },
  computed: {
    url: {
      get() {
        if (this.value === undefined) {
          this.$emit('input', this.default)
          return this.default
        } else return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  watch: {
    value(nVal) {
      this.$emit('on-change', nVal)
    }
  }
}
</script>
<style lang='scss' scoped>
.c-url {
  width: 100%;
  position: relative;
  z-index: 1000;

  .c-col-field {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;

    position: absolute;
    width: 140px;
    line-height: 32px;
    text-align: right;
    top: 0;
    left: -165px;
  }

  .c-caption {
    border: solid 1px #efefef;

    width: 420px;
    padding: 5px;

    .c-caption-input {
      width: 100%;
      display: block;
      background-color: #fff;
      background-image: none;
      border: 0;
      overflow: hidden;
      resize: none;
      outline: 0;
    }

    .c-caption-num {
      color: #666;
      font-size: 85%;

      .m-num-warn {
        color: #ff4400;
      }
    }
  }

  .c-words {
    padding: 4px 0;

    .c-item-word,
    .c-del-a {
      user-select: none;
    }

    .c-item-word {
      line-height: 25px;
      padding: 0 5px;
      white-space: nowrap;
    }

    .c-del-word {
      display: inline-block;
      margin-left: 20px;

      .c-del-a {
        color: #ff4400;
      }
    }

    .ivu-poptip {
      vertical-align: middle;
      margin-top: -3px;
    }
  }

  .c-col-msg {
    position: absolute;
    z-index: 997;
    left: 0;
    bottom: -20px;
    color: #ff4400;
  }
}
</style>
